import { render, staticRenderFns } from "./form-waiting.vue?vue&type=template&id=6305be78&scoped=true"
import script from "./form-waiting.vue?vue&type=script&lang=js"
export * from "./form-waiting.vue?vue&type=script&lang=js"
import style0 from "./form-waiting.vue?vue&type=style&index=0&id=6305be78&prod&lang=css"
import style1 from "./form-waiting.vue?vue&type=style&index=1&id=6305be78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6305be78",
  null
  
)

export default component.exports